import { largeScreen } from 'common/theme'
import { StyledPagination } from 'components/Paging'
import { StyledVehicleStickyBar } from 'modules/VehicleList/VehicleStickyBar.styled'
import { Col } from 'react-bootstrap'
import styled from 'styled-components'

export const StyledSearchResultsPage = styled.div`
  ${StyledVehicleStickyBar} {
    border-radius: 0;
  }

  .custom-control-input:checked ~ .custom-control-label::before {
    border-color: ${({ theme }) => theme.colors.InfinitiOnlyColor};
    background-color: ${({ theme }) => theme.colors.InfinitiOnlyColor};
  }

  .custom-control-input:focus:not(:checked) ~ .custom-control-label::before {
    border-color: ${({ theme }) => theme.colors.InfinitiOnlyColor} !important;
  }
`

export const SearchFilterColumn = styled(Col)`
  @media (max-width: ${largeScreen}) {
    display: none;
  }
  border-right: 1px solid #e5e5e5;
`

export const StyledTopPaging = styled.div`
  ${StyledPagination} {
    justify-content: flex-end;
  }
  @media (max-width: ${largeScreen}) {
    display: none;
  }
`
